import { Component, Inject } from '@angular/core';
import { Budget, BudgetSummary } from '../../store/reselectors/budget.data';
import { PaymentGridData, BudgetSectionGridData, CashFlowGridData } from '../../helpers/grid-helpers';
import { Dictionary } from '@ngrx/entity';
import { Wrapper } from '../../components/wrapper.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { BudgetSnapshotDialogData } from './costs-view-dialog.component';
import { makeBudgetReport } from '../../helpers/budget-helpers';
import { makeCashFlowGrid } from '../../store/reselectors/budget.reselector';
import { BigDialogWrapperComponent } from 'src/app/components/wrappers/big-dialog-wrapper.component';
import { CommonModule } from '@angular/common';
import { BudgetReportViewComponent } from './budget-report-view.component';

@Component({
    selector: 'budget-summary-view',
    templateUrl: './summary-view-dialog.html',
    styleUrls: ['./revenue.scss', './summary-view-dialog.scss'],
    standalone: true,
    imports: [BigDialogWrapperComponent, CommonModule, BudgetReportViewComponent],
})
export class BudgetSummaryViewDialogComponent extends Wrapper<BudgetSummaryViewDialogComponent>  {

  deleteText = 'Are you sure you want to delete this summary snapshot of the budget?'
  scheduleGridDatas: Dictionary<PaymentGridData[]> = {}
  sectionGridDatas: Dictionary<BudgetSectionGridData[]> = {}
  budget: Budget
  budgetSummary: BudgetSummary
  cashFlowGrid: CashFlowGridData[]
  fullBudget: Budget
  loading = false
  readonly api = `${environment.functionsURL}api/app`;

  constructor(public dialogRef: MatDialogRef<BudgetSummaryViewDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: BudgetSnapshotDialogData) {
    super()
    this.downloadSnapshot()
    this.subProp(this.store.select('budget', 'budget'), 'fullBudget')
  } 

  exit() {
    this.dialogRef.close()
  }

  async downloadSnapshot() {
    try {
      this.loading = true
      const url = `${this.api}/load-budget-snapshot` // need to create
      const filePath = `summarySnapshots/${this.data.eventId}/${this.data.info.id}`
      const data = await this.take1(this.http.post(url, { filePath })) as Budget
      if (!data) {
        console.log("NO DATA!")
        return
      }
      console.log({ data })
      this.budget = data
      this.budgetSummary = makeBudgetReport(data)
      console.log({ budgetSummary: this.budgetSummary })
      this.cashFlowGrid = makeCashFlowGrid(this.budgetSummary, this.budget)
      console.log({ cashFlowGrid: this.cashFlowGrid })
    } catch (error) {
      console.log(error)
    } finally {
      this.loading = false
    }


  }

  async delete() {
    this.fullBudget.summarySnapshots = this.fullBudget.summarySnapshots.filter(s => s.id !== this.data.info.id)
    await this.budgetService.updateBudget(this.data.eventId, this.fullBudget)
    this.exit()
  }
}
